import BasePageView from "components/core/BasePageView/BasePageView";
import useSellerContext from "hooks/useSellerContext";
import PlanShipmentDesktop from "./PlanShipmentDesktop";
import PlanShipmentMobile from "./PlanShipmentMobile";

const PlanShipmentView = () => {
  const { currentSellerDetail, allSellersDetails, handleProfileNavigate } = useSellerContext();

  return (
    <BasePageView
      DesktopView={PlanShipmentDesktop}
      MobileView={PlanShipmentMobile}
      headerProps={{
        showSubHeader: true,
        sellerDetail: currentSellerDetail,
        allSellerDetails: allSellersDetails,
        handleProfile: handleProfileNavigate,
      }}
    />
  );
};

export default PlanShipmentView;
